import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../Localization/LanguageLayout";

export default function ScrollUp() {
  const location = useLocation();
  const language = useLanguage();
  const [prevLanguage, setPrevLanguage] = useState(language);

  useEffect(() => {

    if (!window) return;
    if (prevLanguage !== language) {
      setPrevLanguage(language);
      return;
    }
    if (location?.state?.dontScrollUp) return;

    if (location?.hash) return;


    window.scrollTo(0, 0);

  }, [location, language]);

  return null;
}
